<template>
    <a class="btn-link" href="javascript:void(0)" @click="openModal">
        <span v-if="daysSinceAnnualTraining >= 366" class="text-danger font-weight-bold">
            {{ annualTrainingDue }}
        </span>
        <span class="text-warning font-weight-bold" v-else-if="daysSinceAnnualTraining > (366 - 90)">
            {{ annualTrainingDue }}
        </span>
        <span v-else class="text-success font-weight-bold">
            {{ annualTrainingDue }}
        </span>
    </a>

</template>

<script>
import eventBus from '@/event-bus';

export default {
    props: {
        _daysSinceAnnualTraining: {
            type: Number
        },
        _annualTrainingDue: {
            type: String
        },
        employee: {
            type: Object
        }
    },
    data() {
        return {
            annualTrainingDue: this._annualTrainingDue,
            daysSinceAnnualTraining: this._daysSinceAnnualTraining
        }
    },
    mounted() {
        eventBus.$on('annualTrainingUpdated', this.updateDate)
    },
    methods: {
        openModal() {
            eventBus.$emit('annualTrainingModalOpened', {employee: this.employee, annualTrainingDue: this.annualTrainingDue})
        },
        updateDate($event){
            if ($event.employeeId === this.employee.id) {
                this.daysSinceAnnualTraining = $event.daysSinceAnnualTraining;
                this.annualTrainingDue = $event.annualTrainingDue;
            }
        }
    }
}
</script>
